import {getValidSignThemeRootString} from '@ValidSignBV/theme-switcher';

export function getBrandHostAppVariables(brand) {
    if (!brand) return {};

    const brandVariables = {};

    if (brand.font_color) {
        brandVariables['brand-color'] = brand.font_color;
    }
    if (brand.link_color) {
        brandVariables['link-color'] = brand.link_color;
    }
    if (brand.button_background_color) {
        brandVariables['button-background-color'] = brand.button_background_color;
        brandVariables['button-primary-background-color'] = brand.button_background_color;
        brandVariables['button-primary-border-color'] = brand.button_background_color;
        brandVariables['button-primary-background-color-hover'] = brand.button_background_color;
        brandVariables['button-primary-border-color-hover'] = brand.button_background_color;
    }
    if (brand.button_text_color) {
        brandVariables['button-color'] = brand.button_text_color;
        brandVariables['button-primary-color'] = brand.button_text_color;
        brandVariables['button-primary-color-hover'] = brand.button_text_color;
    }

    return {
        light: brandVariables,
        dark: brandVariables,
        lightContrast: brandVariables
    };
}

export const getSignerThemeAsString = ({theme, brand} = {}) => {
    const hostAppVariables = getBrandHostAppVariables(brand);

    return getValidSignThemeRootString({theme, hostAppVariables});
};
